import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cloudinary } from 'services/cloudinary';

import { XmStore } from 'services/store';

@Component({
    selector: 'xm-pay-as-you-go-modal',
    templateUrl: 'pay-as-you-go.html',
    styleUrls: ['pay-as-you-go.scss'],
    standalone: false
})
export class XmPayAsYouGoModal implements OnInit {
    public pageData: CmsPayAsYouGoModal;
    public imagePrimary: MediaImageOptions;
    public features: PayAsYouGoFeaturesModal[] = [];
    public featureDescription: string;

    private dialogRef: MatDialogRef<XmPayAsYouGoModal>;

    constructor(xmStore: XmStore, dialogRef: MatDialogRef<XmPayAsYouGoModal>, @Inject(MAT_DIALOG_DATA) pageData: CmsPayAsYouGoModal) {
        Object.assign(this, { xmStore, dialogRef, pageData });
    }

    public ngOnInit(): void {
        this.imagePrimary = {
            mobile: Cloudinary.generateMediaFromCms(this.pageData.iconPrimary)
        };

        this.pageData.features.forEach((feature: PayAsYouGoFeatures) => {
            this.features.push({
                description: feature.description,
                imageOption: {
                    mobile: Cloudinary.generateMediaFromCms(feature.icon)
                }
            });
        });
        this.featureDescription = this.pageData.gtpEnhancementFeatureDescription;
    }

    public close(action: string): void {
        const response: ModalResponse = {
            close: action === 'close',
            primary: action === 'primary',
            secondary: action === 'secondary'
        };

        this.dialogRef.close(response);
    }
}
